import SaversShipmentSearch from './SaversShipmentSearch';

const SaversFilterContent = ({ form }) => {
  return (
    <div className="filter-collapse-container px-16">
      <SaversShipmentSearch form={form} />
    </div>
  );
};

export default SaversFilterContent;
